export function initFAQBlocks() {
    const blocks = [].slice.apply(document.querySelectorAll('.rb-fAQ'));
    blocks.forEach(initFAQBlockInstance);
}

/**
 *
 * @param {HTMLElement} root
 */
export function initFAQBlockInstance(root) {

}
